import { useState, useEffect } from 'react';
import { User } from '@supabase/supabase-js';
import { supabase } from '../lib/supabase';

const ADMIN_EMAILS = [
  'admin@mathandphysicsvault.com',
  'mathandphysicsvault@gmail.com',
];

export function useAuth() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!supabase) {
      setLoading(false);
      return;
    }

    supabase.auth.getSession().then(({ data: { session }, error }) => {
      if (error && error.message?.includes('Refresh Token Not Found')) {
        supabase!.auth.signOut();
        setUser(null);
      } else {
        setUser(session?.user ?? null);
      }
      setLoading(false);
    }).catch(() => {
      setUser(null);
      setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (event === 'SIGNED_OUT') {
          setUser(null);
        } else {
          setUser(session?.user ?? null);
        }
        setLoading(false);
      }
    );

    return () => subscription.unsubscribe();
  }, []);

  const signOut = async () => {
    if (supabase) {
      await supabase.auth.signOut();
    }
  };

  // Reactive boolean — updates immediately when user state changes
  const adminUser = user?.email
    ? ADMIN_EMAILS.includes(user.email.toLowerCase())
    : false;

  // Keep isAdmin() function for backward compatibility
  const isAdmin = () => adminUser;

  return {
    user,
    loading,
    signOut,
    isAdmin,
    adminUser,
  };
}
